export const columns: TableColumn[] = [
        {
          Header: "Sl.No",
          accessor: "slno",
        },
        {
          Header: "tableCommon.batch_code",
          accessor: "batch_number",
        },
        {
          Header: "tableCommon.seriel_number",
          accessor: "serial_number",
        },
        {
          Header: 'Autoclave Ends In ',
          accessor: 'autoclaveEndTime',
        },
        {
          Header: "Activity Type",
          accessor: "plate_type",
        },
        {
          Header: "Plate Status",
          accessor: "status",
        },
        {
          Header: 'Autoclaved by',
          accessor: 'autoclave_user',
        },


        // {
        //   Header: "Exposed Time",
        //   accessor: "exposed_time",
        // },
        // {
        //   Header: "Exposed By",
        //   accessor: "exposed_by",
        // },
        // {
        //   Header: "Exposure Area Name",
        //   accessor: "exposure_area_name",
        // }, 
        // {
        //   Header: "Incubated by",
        //   accessor: "incubated_by",
        // },
        // {
        //   Header: "Incubation Area Name",
        //   accessor: "incubation_area_name",
        // },      
       
        // {
        //   Header: 'Colony Count',
        //   accessor: 'colony_count',
        // },
       
  ];


export const HistoryColumns: TableColumn[] = [
  // {
  //   Header: "Sl.No",
  //   accessor: "slno",
  // },
  // {
  //   Header: "Batch Code",
  //   accessor: "batch_number",
  // },
  // {
  //   Header: "Serial Number",
  //   accessor: "serial_number",
  // },
  // {
  //   Header: "Exposed Time",
  //   accessor: "exposed_time",
  // },
  // {
  //   Header: "Exposed By",
  //   accessor: "exposed_by",
  // },
  // {
  //   Header: "Exposure Name",
  //   accessor: "exposure_area_name",
  // },
  // {
  //   Header: "Incubation duration",
  //   accessor: "incubation_duration",
  // },
  // {
  //   Header: "Incubated By",
  //   accessor: "incubated_by",
  // },
  // {
  //   Header: "Incubation Name",
  //   accessor: "incubation_area_name",
  // },
  // {
  //   Header: "Autoclave Start Time",
  //   accessor: "autoclave_start_time",
  // },
  // {
  //   Header: "Autoclave End Time",
  //   accessor: "autoclave_end_time",
  // },
  // {
  //   Header: "Status",
  //   accessor: "status",
  // },
  // {
  //   Header: 'Colony Count',
  //   accessor: 'colony_count',
  // }
  {
    Header: "Sl.No",
    accessor: "slno",
  },
  {
    Header: "tableCommon.batch_code",
    accessor: "batch_number",
  },
  {
    Header: "tableCommon.seriel_number",
    accessor: "serial_number",
  },
  {
    Header: 'Autoclave Ends In ',
    accessor: 'autoclave_end_time',
  },
  {
    Header: "Activity Type",
    accessor: "plate_type",
  },
  {
    Header: "Plate Status",
    accessor: "status",
  },
  {
    Header: 'Autoclaved by',
    accessor: 'autoclave_user',
  },

]

  
interface TableColumn {
    Header: string;
    accessor: string;
}